import { action, makeObservable, observable } from 'mobx'

import CDConfigurationFormFieldId from '~/client/src/desktop/enums/ConcreteDirectConfigurationFormFieldId'
import MaturixProjectsStore from '~/client/src/shared/stores/domain/MaturixStores/MaturixProjects.store'
import * as e from '~/client/src/shared/stores/EventStore/eventConstants'
import EventContext from '~/client/src/shared/stores/EventStore/EventContext'

export default class IntegrationsSetUpStore {
  protected requiredConcreteDirectFieldIds = [
    CDConfigurationFormFieldId.CDBaseURL,
  ]
  @observable public maturixToken: string = ''

  public constructor(
    private readonly maturixProjectsStore: MaturixProjectsStore,
  ) {
    makeObservable(this)
  }

  public onProjectUpdate = (eventContext: EventContext) => {
    const [eventType] = eventContext.event

    if (eventType === e.GET_MATURIX_CONFIGURATION_SUCCESS) {
      this.setIntegrationDataValues()
    }
  }

  @action
  public setIntegrationDataValues() {
    this.maturixToken = this.maturixProjectsStore.maturixToken ?? ''
  }
}
